import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";

class CallRegistsOtherCalls extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chartOptions: {
      title: {
        text: "Leads sem conversão",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      labels: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
      ],
      legend: {
        show: true,
        position: "right",
      },
      colors: ["#088F8F"],
    },
  };

  render() {
    return (
      <div class="graf_leads_without_conversion">
        {this.props.callRegistsOtherCalls && (
          <Chart
            title={this.state.title}
            options={this.state.chartOptions}
            series={[
              {
                name: "",
                data: [
                  this.props.callRegistsOtherCalls.find((s) => s.id === 1)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 1)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 2)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 2)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 3)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 3)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 4)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 4)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 5)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 5)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 6)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 6)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 7)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 7)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 8)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 8)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 9)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 9)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 10)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 10)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 11)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 11)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 12)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 12)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 13)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 13)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 14)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 14)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 15)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 15)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 16)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 16)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 17)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 17)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 18)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 18)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 19)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 19)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 20)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 20)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 21)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 21)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 22)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 22)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 23)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 23)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 24)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 24)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 25)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 25)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 28)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 28)
                        .count
                    : 0 +
                      this.props.callRegistsOtherCalls.find((s) => s.id === 29)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 29)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 30)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 30)
                        .count
                    : 0,
                  this.props.callRegistsOtherCalls.find((s) => s.id === 31)
                    ? this.props.callRegistsOtherCalls.find((s) => s.id === 31)
                        .count
                    : 0,
                ],
              },
            ]}
            type="bar"
            width="480"
            height="370"
          />
        )}
        <div class="subtitle-grafs mt-2 text-center">
          Dados referentes{" "}
          {this.props.filter_date_other_calls === null ? (
            <span>ao mês corrente</span>
          ) : (
            <span>ao periodo de tempo indicado no filtro</span>
          )}
        </div>

        <div class="subtitle-grafs text-center mt-4 mb-3">
          <u>Legenda</u>
        </div>
        <div class="row ml-2">
          <div class="col-4">
            <div class="subtitle-grafs">
              <strong>A: </strong>Acompanhamento
            </div>
            <div class="subtitle-grafs">
              <strong>B: </strong>Apoio a cliente
            </div>
            <div class="subtitle-grafs">
              <strong>C: </strong>Caso social
            </div>
            <div class="subtitle-grafs">
              <strong>D: </strong>Contato suspeito
            </div>
            <div class="subtitle-grafs">
              <strong>E: </strong>Contacto repetido
            </div>
            <div class="subtitle-grafs">
              <strong>F: </strong>Curiosidade
            </div>
          </div>
          <div class="col-4">
            <div class="subtitle-grafs">
              <strong>G: </strong>Engano
            </div>
            <div class="subtitle-grafs">
              <strong>H: </strong>Falha na conversão
            </div>
            <div class="subtitle-grafs">
              <strong>I: </strong>Falta de oferta
            </div>
            <div class="subtitle-grafs">
              <strong>J: </strong>Não atende
            </div>
            <div class="subtitle-grafs">
              <strong>K: </strong>Não possui informação
            </div>
            <div class="subtitle-grafs">
              <strong>L: </strong>Outra valência
            </div>
          </div>
          <div class="col-4">
            <div class="subtitle-grafs mr-4">
              <strong>M: </strong>Parcerias
            </div>
            <div class="subtitle-grafs mr-4">
              <strong>N: </strong>Pedido (sem ser novo)
            </div>
            <div class="subtitle-grafs mr-4">
              <strong>O: </strong>Vendas
            </div>
            <div class="subtitle-grafs mr-4">
              <strong>P: </strong>Em chamada
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CallRegistsOtherCalls;
